/**
 * @param  {string} cookieName
 * @returns string
 */
export function getCookie(cookieName: string): string | null {
	const re = new RegExp(cookieName + '=([^;]+)');
	const value = re.exec(document.cookie);
	return value !== null ? unescape(value[1]) : null;
}

/**
 * @todo Only for testing purposes!
 * @param  {string} cookieName
 * @param  {number=0} expiry
 * @param  {string=''} cookieValue
 */
export function setCookie(cookieName: string, expiry: number = 0, cookieValue: string = ''): void {
	const date = new Date();
	date.setTime(date.getTime() + expiry * 24 * 60 * 60 * 1000);
	const expires = 'expires=' + date.toUTCString();

	let cookieRestrictions: string = `; path='/'; secure;`;
	if (process.env.NODE_ENV === 'development') {
		cookieRestrictions = '; path=/';
	}

	document.cookie = `${cookieName}=${cookieValue}; ${expires} ${cookieRestrictions}`;
}

/**
 * Regular expression to check if a string only contains numbers
 * Usedul for video IDs (Vimeo's video ids are always numbers)
 * @param  {string} string
 * @returns boolean
 */
export function containsNumbersOnly(string: string): boolean {
	const pattern = new RegExp(/^[0-9]+$/);
	return pattern.test(string);
}

/**
 * Returns an MediaQueryList which states whether the breakpoint matches or not
 * Executes a callback function (if given) whenever the media match changes
 * @param {String} breakpoint
 * @param {Function} callback
 * @return {MediaQueryList}
 */
export function matchBreakpoint(breakpoint: string = 'm', callback: () => any): MediaQueryList {
	if (!['s', 'm', 'l', 'xl'].includes(breakpoint)) {
		console.warn('matchBreakpoint(): undefined breakpoint ' + breakpoint);
	}
	const breakpointValue = getComputedStyle(document.documentElement).getPropertyValue(`--uk-breakpoint-${breakpoint}`);
	const matchMedia = window.matchMedia(`(min-width: ${breakpointValue})`);

	if (typeof callback === 'function') {
		if (typeof matchMedia.addEventListener !== 'undefined') {
			matchMedia.addEventListener('change', callback);
		} else {
			// IE11 and Edge legacy
			matchMedia.addListener(callback);
		}
	}

	return matchMedia;
}
